import tools from 'utilities/tools';

export const bufferedSaveAddressInformation = ({ handleNextStep, handleSave, userProfileForm }, ...args) => {
    tools.aggregatedDebounce(() => {
        const isValid = args.every(([field]) => userProfileForm[field] && userProfileForm[field].valid);

        const stuff = args.reduce((acc, [field, value]) => {
            if (field !== 'address' && userProfileForm[field] && userProfileForm[field].valid) {
                acc[field] = value;
            }

            return acc;
        }, {});

        const stuffHasLength = Object.keys(stuff).length > 0;
        stuffHasLength && handleSave('homeAddress', stuff);

        handleNextStep(isValid);
    }, 1000)({ handleNextStep, handleSave, userProfileForm }, args);
};
